import React from 'react';
import {useTranslation} from 'react-i18next';

export default function PriceExcludesVatNote({className = '', prominent = false}) {
    const {t} = useTranslation();

    return (
        <p className={`${prominent
            ? 'rounded-xl border border-violet-200 bg-violet-50 px-5 py-4 text-center text-base font-semibold text-violet-900 shadow-sm dark:border-violet-800 dark:bg-violet-950/40 dark:text-violet-100'
            : 'text-xs text-gray-500 dark:text-gray-400'} ${className}`}>
            {t('subscription.prices-exclude-vat', {defaultValue: 'Ceny jsou uvedeny bez DPH. DPH bude uplatněna dle platných právních předpisů'})}
        </p>
    );
}
